import data from '../'
export const whatsappMarketting = [
  {
    heading: "Kickstart your WhatsApp Marketing Journey",
    para1: `
        <p>Tap into the power of WhatsApp Marketing & achieve up to 150X ROI.</p>
        <p>Official WhatsApp Marketing Software to Launch, Automate & Scale Your Campaigns.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp Marketing 1.webp")
  },
  {
    heading: "Promotional Offer message",
    para1: `
        <p>Send hyper-targeted promotional campaigns to enhance the customer journey within a single platform.</p>
        <p><strong>Send:</strong></p>
        <ul>
          <li>Coupons</li>
          <li>Discount Code</li>
          <li>Limited Time Offer</li>
          <li>New Product List</li>
          <li>Exclusive First Launch</li>
          <li>Sale & re-stocked Item</li>
        </ul>
      `,
    img: require("../assets/images/gridimg/WhatsAppMarketing 2.webp")

  },
  {
    heading: "Engage customers with interactive notifications",
    para1: `
        <ul>
          <li>Elevate campaign performance with rich media – images, videos, PDFs, and more.</li>
          <li>Use elements like CTA & Quick Reply buttons to engage customers.</li>
        </ul>
      `,
    img: require("../assets/images/gridimg/WhatsApp Marketing 3.webp")
  },
  {
    heading: "Monitor Campaign Performance",
    para1: `
        <ul>
        <li>Monitor campaign performance stats like the number of messages Sent, Delivered, Read and Replied to.</li>
        <li>Build campaign audiences based on these insights.</li>
        </ul>

      `,
    img: require("../assets/images/gridimg/WhatsApp Marketing 4.webp")

  },
  {
    heading: "Order Update",
    para1: `
    <ul>
        <li>Make ordering simple by sending catalogs as a part of your notification campaigns.</li>
        <li>Enable customers to seamlessly browse through catalogs, access their past purchases and easily place new orders – all within the confines of a single, fluid conversation on WhatsApp.</li>
      </ul>
        `,
    img: require("../assets/images/gridimg/WhatsApp Marketing 5.webp")

  },
  {
    heading: "One-time Passwords",
    para1: `
    <ul>
        <li>With WhatsApp’s end-to-end encryption, messages remain exclusively accessible to the recipient.</li>
        <li>This enhances reliability for transmitting OTPs and reduces the vulnerability of dual passwords & exposure to potential hackers.</li>
     </ul>
        `,
    img: require("../assets/images/gridimg/WhatsApp Marketing 6.webp")
  }
];

export const whatsapp_business_services = [
  {
    id: 1,
    title: "Send Business Messages",
    colorClass: "yellow-service",
    dotClass: "yellow-dot",
    color: "#FFC250",
    points: "Send messages to customers who have opted-in to receive messages from the business.",
  },
  {
    id: 2,
    title: "Use Commerce Features",
    colorClass: "red-service",
    dotClass: "red-dot",
    color: "#E9536C",
    points: "Utilize features like catalogs and payments to sell products and services.",
  },
  {
    id: 3,
    title: "Provide Customer Support",
    colorClass: "pink-service",
    dotClass: "pink-dot",
    color: "#F4B1B8",
    points: "Offer customer support and answer questions through WhatsApp.",
  },
  {
    id: 4,
    title: "Personalized Interactions",
    colorClass: "blue-service",
    dotClass: "blue-dot",
    color: "#1EACC0",
    points: "Uses customer data to offer personalized recommendations and offers, enhancing the customer experience.",
  },
];

export const WhatsappBusinessdata = [
  {
    heading: "3X Your Business Growth with WhatsApp Business API",
    para1: `
      <p>Get Free WhatsApp Business API Access – No Hidden Fees with SMS ZOO ZOO.</p>
      <p>Apply WhatsApp API for free now and unlock the power of WhatsApp Engagement!</p>
    `,
    img: require("../assets/images/gridimg/WhatsApp API 1.webp")
  },
  {
    heading: "What is WhatsApp Business API?",
    para1: `
      <p>The WhatsApp Business API is a powerful tool for businesses to communicate with customers at scale.</p>
      <p>With SMS ZOO ZOO, you get free access to Official WhatsApp Business API. That's right! No more worries about numbers getting blocked or complex setups.</p>
    `,
    img: require("../assets/images/gridimg/WhatsApp API 2.webp")
  },
  {
    heading: "SMS ZOO ZOO Official WhatsApp API enables",
    para1: `
      <ul>
        <li>Automated messaging Save time and resources by automating responses to frequently asked questions, order updates, and more.</li>
        <li>Bulk notifications Send timely updates, promotions, and alerts to thousands of customers with just a few clicks.</li>
        <li>Seamless customer support Provide instant, 24/7 support with automated chatbots and/or human agents.</li>
        <li>Integration with CRM and other tools Connect WhatsApp Business API with your existing CRM, analytics tools, and workflows for a unified business ecosystem.</li>
      </ul>
    `,
    img: require("../assets/images/gridimg/WhatsApp API 3.webp")
  },
  {
    heading: "Run Click to WhatsApp Ads",
    para1: `
      <p>Create ads that click directly to WhatsApp, capture leads instantly, and boost conversions.</p>
      <p>See 3-5X more leads & slash your cost per lead.</p>
    `,
    img: require("../assets/images/gridimg/WhatsApp API 4.webp")
  },
  {
    heading: "Build No-code WhatsApp Chatbots in Minutes",
    para1: `
      <p>Effortlessly deploy multiple WhatsApp chatbots with SMS ZOO ZOO's drag-and-drop interface, automating up to 80% of your manual queries.</p>
    `,
    img: require("../assets/images/gridimg/WhatsApp API 5.webp")
  }
];


export const whatsappAdds =[
  
  {
    heading: "Drive 5x More Leads with Click to WhatsApp Ads",
    para1: `
        <ul>
          <li>Create impactful ads that direct users instantly to WhatsApp using high-performance WhatsApp services.</li> 
          <li>Engage customers where they are most active through Facebook and Instagram conversations.</li>
        </ul>
      `,
    img: require("../assets/images/gridimg/click to whatsapp ad 1.webp")
  },
  {
    heading: "Boost Your Business with Click-to-WhatsApp Ads",
    para1: `
        <p>Reach out to potential customers where they are most engaged. Utilize Click-to-WhatsApp ads on Facebook and Instagram to encourage viewers to start a dialogue with your business.</p>
        <ul>
          <li>Increase in conversion rate</li>
          <li>Improve customer engagement</li>
          <li>Personalized retargeting</li>
        </ul>
      `,
    img: require("../assets/images/gridimg/click to whatsapp ad 2.webp")
  },
  {
    heading: "Create & Run Ads with Ease",
    para1: `
        <p>Recharge ad credits, create and launch campaigns, segregate leads, re-engage audiences with broadcasts, and drive conversions - all using integrated WhatsApp services.</p>
      `,
    img: require("../assets/images/gridimg/click to whatsapp ad 3.webp")
  },
  {
    heading: "Increase your ROAS🔥",
    para1: `
        <p>Retarget generated leads on WhatsApp & drive 7.5x ROAS.</p>
      `,
    img: require("../assets/images/gridimg/click to whatsapp ad 4.webp")
  },
  {
    heading: "View Analytics",
    para1: `
        <p>Monitor insightful ad analytics seamlessly within one single dashboard.</p>
      `,
    img: require("../assets/images/gridimg/click to whatsapp ad 5.webp")
  }
]



export const whatsappChatbotsAdds = [
  {
    heading: "Create No-code WhatsApp Chatbots in Minutes",
    para1: `
        <ul>
          <li>Build multiple dynamic WhatsApp Chatbots easily with a drag-and-drop interface.</li>
          <li>Enable multiple WhatsApp Chatbots in one account.</li>
          <li>Automate 80% of manual queries.</li>
        </ul>
        ⚡️Powered by Official WhatsApp Business API
      `,
    img: require("../assets/images/gridimg/WhatsApp chatbot 1.webp")
  },
  {
    heading: "Turn Leads into Customers Automatically",
    para1: `
        <p>Let your WhatsApp chatbot service qualify leads, answer queries, and drive conversions without human intervention - saving time and improving efficiency.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp chatbot 2.webp")
  },
  {
    heading: "A Chatbot Builder for Non-techies",
    para1: `
        <p>Build multiple WhatsApp Chatbots easily, thanks to a drag-and-drop interface.</p>
        <p>No coding expertise required—perfect for businesses looking for easy automation.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp chatbot 3.webp")
  },
  {
    heading: "24x7 Support & Sales Automation on WhatsApp",
    para1: `
        <p>Automate support and sales processes with dynamic chatbots answering customer queries instantly.</p>
        <p>Help customers arrive at a sales decision 3x faster with automated assistance.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp chatbot 4.webp")
  },
  {
    heading: "Seamless Integration with Business Tools",
    para1: `
        <p>Connect your chatbot with WhatsApp Catalogues and WhatsApp Pay.</p>
        <p>Showcase your catalog and drive payments directly within WhatsApp for a smooth user experience.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp chatbot 5.webp")
  }
];




export const whatsappBlueTickAdds = [
  {
    heading: "Get Verified with WhatsApp Blue Tick",
    para1: `
        <p>Win customer trust instantly! Get your business verified on WhatsApp.</p>
        <p>Apply for the Blue tick verification with SMS ZOO ZOO.</p>
        ⚡️Powered by Official WhatsApp Business API
      `,
    img: require("../assets/images/gridimg/WhatsApp Blue tick 1.webp")
  },
  {
    heading: "What is WhatsApp Blue Tick?",
    para1: `
        <p>The WhatsApp Blue Tick (earlier WhatsApp Green Tick) is your official verification badge that appears next to a business's name on WhatsApp.</p>
        <p>It indicates that the account is authentic and officially verified by WhatsApp.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp Blue tick 2.webp")
  },
  {
    heading: "See Why Verified WhatsApp Accounts Win More Customers",
    para1: `
        <p>A verified WhatsApp business account appears far more authentic & reliable compared to a non-verified WhatsApp business API account.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp Blue tick 3.webp")
  },
  {
    heading: "Increase Your Message Open Rate by Up to 70% with Verified WhatsApp Badge",
    para1: `
        <p>People engage more with verified businesses.</p>
        <p>A blue tick signifies authenticity, leading to better visibility, higher open rates, and stronger customer relationships.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp Blue tick 4.webp")
  },
  {
    heading: "Reduce the Risk of Getting Banned",
    para1: `
        <p>Unverified accounts risk being marked as spam.</p>
        <p>The blue tick reassures users that your messages are legitimate, reducing blocks and improving trust.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp Blue tick 5.webp")
  },
  {
    heading: "Stand Out in Competitive Markets",
    para1: `
        <p>In a crowded space, credibility matters.</p>
        <p>A verified badge sets your brand apart, builds trust, and enhances your reputation—all driving business growth.</p>
      `,
    img: require("../assets/images/gridimg/WhatsApp Blue tick 6.webp")
  }
];